import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import { getErrorMessage } from 'helpers/errors';
import { getHistóricoCuotas, Cuota } from 'features/matriculates/matriculatesAPI';
import { fCurrency } from 'helpers/formatNumber';

export default function HistoricoCuotas() {
  const [showAlert, message, alert] = useAlert(false, '');
  const [cuotas, setCuotas] = useState<Cuota[]>([]);

  useEffect(() => {
    getHistóricoCuotas()
      .then(data => {
        setCuotas(data);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudieron obtener las cuotas');
      });
  }, []);

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Histórico de Cuotas</Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Año</th>
                    <th>Concepto</th>
                    <th style={{ textAlign: 'right' }}>Cuota</th>
                    <th style={{ textAlign: 'right' }}>Recargo</th>
                    <th style={{ textAlign: 'right' }}>Pagado</th>
                    <th>Fecha de Pago</th>
                    <th>Convenio</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    cuotas.map((row, index) => (
                      <tr key={`row_${row.matricula}_${index}`}>
                        <td>{row.anio}</td>
                        <td>{row.concepto}</td>
                        <td style={{ textAlign: 'right' }}>{fCurrency(row.cuota)}</td>
                        <td style={{ textAlign: 'right' }}>{fCurrency(row.recargo)}</td>
                        <td style={{ textAlign: 'right' }}>{fCurrency(row.pagado)}</td>
                        <td>{row.fechaDePago.split('-').join('/')}</td>
                        <td>{row.convenio ? 'Sí' : 'No'}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
